export default __webpack_public_path__ + "static/media/icon-kaiser.fd485120.svg";